import { render } from "./FormSection.vue?vue&type=template&id=3922b28c"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/FormSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3922b28c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3922b28c', __exports__)) {
    api.reload('3922b28c', __exports__)
  }
  
  module.hot.accept("./FormSection.vue?vue&type=template&id=3922b28c", () => {
    api.rerender('3922b28c', render)
  })

}


export default __exports__